import { indexTopics } from '@/mocks/homeData';

export default function SectionIndex() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-4">
            <i className="ri-compass-3-line"></i>
            <span>分类导航</span>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">专题索引</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            八大漫画分类，快速找到你喜欢的漫画类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {indexTopics.map((topic, i) => (
            <a
              key={i}
              href={`#cards`}
              onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
              className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70 hover:border-primary-200/60 hover:bg-primary-50/30 transition-all duration-200 flex flex-col items-center text-center gap-3 cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100/60 text-primary-500 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${topic.icon} text-xl`}></i>
              </div>
              <div>
                <h3 className="font-heading text-sm md:text-base text-foreground-900 mb-1">{topic.title}</h3>
                <p className="text-xs text-foreground-400 mb-1">{topic.desc}</p>
                <span className="text-xs text-primary-500 font-medium">{topic.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}